import State from "@/helpers/pattern/state";
import { Archivos } from "@/models/generales/archivos";
import { modelIsModified } from "@/helpers/vue-mc";
import archivosAPI from "@/services/generales/archivos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";

/**
 * State Pattern for status form
 */
export default class ArchivosStates extends State {
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */

  constructor(data) {
    super(data);
  }

  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.archivo = new Archivos();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.archivo) || $data.view.action.submit.busy || !modelIsModified($data.archivo);
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, subtipo, tipo, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              return false;
            }

            if (!$data.listadoArchivos.find((itemFind) => itemFind.name.startsWith(this.archivo.descripcion))) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", "Ya existe un nombre de archivo similar");
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await archivosAPI.save({
              clave: null
              , descripcion
              , tipo
              , subtipo
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.archivosTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, tipo, subtipo, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          $data.archivo = new Archivos({
            clave
            , descripcion
            , subtipo
            , tipo
            , status
          });

          this.resetValidators();
        }
        , async submit({ $data, $setState }, { clave, descripcion, tipo, subtipo, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await archivosAPI.update({
              clave
              , descripcion
              , subtipo
              , tipo
              , status
            });

            $data.$refs.archivosTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/generales/archivos/archivos-state.js